<template>
  <div class="manager_box" style="background:white;min-height:80vh;" v-loading="loading">
    <el-button @click="return_os" style="width:100px;">返回</el-button>
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <p>部门信息</p>
      <div class="create_infor">
        <el-form-item label="员工所属" label-width="120px" class="el_form_item" prop="ed_id">
          <!-- <el-select v-model="form.ed_id" placeholder="员工所属" class='el_input'>
                        <el-option v-for="item in options" :key="item.ed_id" :label="item.ed_name" :value="item.ed_id"></el-option>
          </el-select>-->
          <el-cascader
            v-model="cascader_ed_id"
            :options="options"
            :props="{ checkStrictly: true, label: 'ed_name', value: 'ed_id' }"
            class="el_input"
            @change="cascader_checkStrictly"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="是否已入社保"
          label-width="120px"
          class="el_form_item"
          prop="is_social_security"
        >
          <el-select
            v-model="form.is_social_security"
            value-format="timestamp"
            placeholder="请选择是否已入社保"
            class="el_input"
          >
            <el-option
              v-for="item in is_social_security_options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="职位" label-width='120px' class='el_form_item' prop='position'>
                    <el-input v-model="form.position" class='el_input' placeholder="请输入职位"></el-input>
        </el-form-item>-->
      </div>
      <div class="create_infor">
        <el-form-item label="工作性质" label-width="120px" class="el_form_item" prop="job_type">
          <el-select
            v-model="form.job_type"
            value-format="timestamp"
            placeholder="请选择工作性质"
            class="el_input"
          >
            <el-option
              v-for="item in job_type_options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员类型" label-width="120px" class="el_form_item" prop="staff_status">
          <el-select
            v-model="form.staff_status"
            value-format="timestamp"
            placeholder="请选择人员类型"
            class="el_input"
          >
            <el-option
              v-for="item in staff_status_options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="员工状态" label-width="120px" class="el_form_item" prop="user_status">
          <el-select
            v-model="form.user_status"
            value-format="timestamp"
            placeholder="请选择员工状态"
            class="el_input"
          >
            <el-option
              v-for="item in user_status_options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入职时间" label-width="120px" class="el_form_item" prop="join_time">
          <el-date-picker
            v-model="array_form.join_time"
            value-format="timestamp"
            type="date"
            placeholder="选择入职时间"
            @change="form_item('join_time', array_form.join_time)"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="试用期" label-width="120px" class="el_form_item" prop="internship">
          <el-input v-model="form.internship" class="el_input" placeholder="请输入试用期">
            <template slot="append">月</template>
          </el-input>
        </el-form-item>
        <el-form-item label="转正时间" label-width="120px" class="el_form_item" prop="done_time">
          <el-date-picker
            v-model="array_form.done_time"
            value-format="timestamp"
            type="date"
            placeholder="选择转正时间"
            @change="form_item('done_time', array_form.done_time)"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="离职时间" label-width="120px" class="el_form_item">
          <el-date-picker
            v-model="array_form.leave_time"
            type="date"
            value-format="timestamp"
            placeholder="选择离职时间"
            @change="form_item('leave_time', array_form.leave_time)"
          ></el-date-picker>
        </el-form-item>
      </div>
      <p class="dividing_line"></p>
      <p>基本信息</p>
      <div class="create_infor">
        <el-form-item label="姓名" label-width="120px" class="el_form_item" prop="name">
          <el-input v-model="form.name" class="el_input" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="120px" class="el_form_item" prop="mobile">
          <el-input
            type="number"
            oninput="if(value.length>11)value=value.slice(0,11)"
            v-model="form.mobile"
            class="el_input"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="年龄" label-width="120px" class="el_form_item" prop="age">
          <el-input
            type="number"
            oninput="if(value.length>3)value=value.slice(0,3)"
            v-model="form.age"
            class="el_input"
            placeholder="请输入年龄"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" label-width="120px" class="el_form_item" prop="gender">
          <el-select v-model="form.gender" placeholder="请选择性别" class="el_input">
            <el-option
              v-for="item in gender_options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="户籍所在地" label-width="120px" class="el_form_item" prop="domicile_place">
          <el-input v-model="form.domicile_place" class="el_input" placeholder="请输入户籍所在地"></el-input>
        </el-form-item>
        <el-form-item label="现住址" label-width="120px" class="el_form_item" prop="present_address">
          <el-input v-model="form.present_address" class="el_input" placeholder="请输入现住址"></el-input>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="出生年月" label-width="120px" class="el_form_item" prop="birth_year">
          <!-- <el-input v-model="array_form.birth" class='el_input' placeholder="请输入出生年月"></el-input> -->
          <el-date-picker
            v-model="array_form.birth"
            value-format="yyyy-M"
            type="month"
            placeholder="选择入出生年月"
            @change="form_birth"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="身份证号" label-width="120px" class="el_form_item" prop="id_card">
          <el-input v-model="form.id_card" class="el_input" placeholder="请输入身份证号" maxlength="18"></el-input>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="婚否" label-width="120px" class="el_form_item" prop="is_marry">
          <el-select v-model="form.is_marry" placeholder="请选择性别" class="el_input">
            <el-option
              v-for="item in is_marry_options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="政治面貌" label-width="120px" class="el_form_item">
          <el-input v-model="form.political" class="el_input" placeholder="请输入政治面貌"></el-input>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="支行" label-width="120px" class="el_form_item">
          <el-input v-model="form.bank_branch" class="el_input" placeholder="请输入支行"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号" label-width="120px" class="el_form_item">
          <el-input
            type="number"
            v-model="form.credit_card_num"
            class="el_input"
            placeholder="请输入银行卡号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="邮箱" label-width="120px" class="el_form_item">
          <el-input v-model="form.email" class="el_input" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="民族" label-width="120px" class="el_form_item">
          <el-input v-model="form.nation" class="el_input" placeholder="请输入民族"></el-input>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="学历" label-width="120px" class="el_form_item">
          <el-input v-model="form.education_background" class="el_input" placeholder="请输入学历"></el-input>
        </el-form-item>
        <el-form-item label="专业" label-width="120px" class="el_form_item">
          <el-input v-model="form.specialty" class="el_input" placeholder="请输入专业"></el-input>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="技能" label-width="120px" class="el_form_item">
          <el-input v-model="form.skill" class="el_input" placeholder="请输入技能"></el-input>
        </el-form-item>
        <el-form-item label="员工号" label-width="120px" class="el_form_item">
          <el-input v-model="form.job_num" class="el_input" placeholder="请输入员工号"></el-input>
        </el-form-item>
      </div>
      <div class="create_infor">
        <el-form-item label="身体情况" label-width="120px" class="el_form_item">
          <el-input v-model="form.physical_condition" class="el_input" placeholder="请输入身体情况"></el-input>
        </el-form-item>
        <el-form-item label="爱好" label-width="120px" class="el_form_item">
          <el-input v-model="form.hobby" class="el_input" placeholder="请输入爱好"></el-input>
        </el-form-item>
      </div>

      <p class="dividing_line"></p>
      <div class="optional_center">
        <p>教育经历</p>
        <div class="add_options">
          <el-button type="warning" @click="add_options(0)" style="width:100%;">添加</el-button>
        </div>
      </div>
      <div v-for="(item, index) in education_reversedMessage" :key="item.id">
        <div v-if="index != 0">
          <p class="dividing_line for_add_options_p"></p>
          <div class="delete_center">
            <el-button type="danger" @click="add_delete(0, item.id)" style="width:80px;">删除</el-button>
          </div>
        </div>
        <div class="create_infor">
          <el-form-item label="学校" label-width="120px" class="el_form_item">
            <el-input
              v-model="education_reversedMessage[index].school_name"
              class="el_input"
              placeholder="请填写学校"
            ></el-input>
          </el-form-item>
          <el-form-item label="学历" label-width="120px" class="el_form_item">
            <el-input
              v-model="education_reversedMessage[index].education_background"
              class="el_input"
              placeholder="请填写学历"
            ></el-input>
          </el-form-item>
        </div>
        <div class="create_infor">
          <el-form-item label="专业" label-width="120px" class="el_form_item">
            <el-input
              v-model="education_reversedMessage[index].specialty"
              class="el_input"
              placeholder="请填写专业"
            ></el-input>
          </el-form-item>
          <el-form-item label="毕业时间" label-width="120px" class="el_form_item">
            <el-date-picker
              v-model="education_reversedMessage[index].ed_time"
              type="monthrange"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>
      <p class="dividing_line"></p>
      <div class="optional_center">
        <p>工作经历</p>
        <div class="add_options">
          <el-button type="warning" @click="add_options(1)" style="width:100%;">添加</el-button>
        </div>
      </div>
      <div v-for="(item, index) in work_reversedMessage" :key="item.id">
        <div v-if="index != '0'">
          <p class="dividing_line for_add_options_p"></p>
          <div class="delete_center">
            <el-button type="danger" @click="add_delete(1, item.id)" style="width:80px;">删除</el-button>
          </div>
        </div>

        <div class="create_infor">
          <el-form-item label="公司" label-width="120px" class="el_form_item">
            <el-input
              v-model="work_reversedMessage[index].company_name"
              class="el_input"
              placeholder="请填写公司"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门" label-width="120px" class="el_form_item">
            <el-input
              v-model="work_reversedMessage[index].department_name"
              class="el_input"
              placeholder="请填写部门"
            ></el-input>
          </el-form-item>
        </div>
        <div class="create_infor">
          <el-form-item label="薪资" label-width="120px" class="el_form_item">
            <el-input
              type="number"
              v-model="work_reversedMessage[index].salary"
              class="el_input"
              placeholder="请填写薪资"
            ></el-input>
          </el-form-item>
          <el-form-item label="工作时间" label-width="120px" class="el_form_item">
            <el-date-picker
              v-model="work_reversedMessage[index].work_time"
              type="monthrange"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>
      <p class="dividing_line"></p>
      <div class="optional_center">
        <p>家庭信息</p>
        <div class="add_options">
          <el-button type="warning" @click="add_options(2)" style="width:100%;">添加</el-button>
        </div>
      </div>
      <div v-for="(item, index) in family_reversedMessage" :key="item.id">
        <div v-if="index != '0'">
          <p class="dividing_line for_add_options_p"></p>
          <div class="delete_center">
            <el-button type="danger" @click="add_delete(2, item.id)" style="width:80px;">删除</el-button>
          </div>
        </div>
        <div class="create_infor">
          <el-form-item label="名字" label-width="120px" class="el_form_item">
            <el-input
              v-model="family_reversedMessage[index].family_name"
              class="el_input"
              placeholder="请填写名字"
            ></el-input>
          </el-form-item>
          <el-form-item label="关系" label-width="120px" class="el_form_item">
            <el-input
              v-model="family_reversedMessage[index].family_relation"
              class="el_input"
              placeholder="请填写关系"
            ></el-input>
          </el-form-item>
        </div>
        <div class="create_infor">
          <el-form-item label="手机号" label-width="120px" class="el_form_item">
            <el-input
              type="number"
              oninput="if(value.length>11)value=value.slice(0,11)"
              v-model="family_reversedMessage[index].family_phone"
              class="el_input"
              placeholder="请填写手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="职业" label-width="120px" class="el_form_item">
            <el-input
              v-model="family_reversedMessage[index].family_profession"
              class="el_input"
              placeholder="请填写职业"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="onSubmit">
        <el-button type="warning" @click="onSubmit" style="width:150px; padding: 14px;">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { require } from '@/utils/http_request.js'
export default {
  data() {
    let validatePass = (rule, value, callback) => {
      // 验证手机号
      let zhengze = /^1(3|4|5|6|7|8|9)\d{9}$/
      if (value == '') {
        callback(new Error('请输入手机号'))
      } else if (!zhengze.test(value)) {
        callback(new Error('输入的手机号有误'))
      }
    }
    let validatePass1 = (rule, value, callback) => {
      // 验证手机号
      let zhengze = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (value == '') {
        callback(new Error('请输入身份证号'))
      } else if (!zhengze.test(value)) {
        callback(new Error('输入的身份证有误'))
      }
    }
    let validatePass2 = (rule, value, callback) => {
      // 验证时间
      if (value == '') {
        callback(new Error('请添加时间'))
      } else {
        callback()
      }
    }
    return {
      cascader_ed_id: [],
      value: '',
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile: [{ required: true, validator: validatePass, trigger: 'blur' }],
        age: [{ required: true, message: '请输入年龄', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        // position: [{ required: true, message: '请输入职位', trigger: 'blur' }],
        ed_id: [{ required: true, message: '请选择部门', trigger: 'change' }],
        id_card: [
          { required: true, validator: validatePass1, trigger: 'blur' },
        ],
        is_marry: [
          { required: true, message: '请选择是否婚配', trigger: 'change' },
        ],
        job_type: [
          { required: true, message: '请选择工作性质', trigger: 'change' },
        ],
        staff_status: [
          { required: true, message: '请选择人员类型', trigger: 'change' },
        ],
        user_status: [
          { required: true, message: '请选择员工状态', trigger: 'change' },
        ],
        join_time: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
        internship: [
          { required: true, message: '请输入试用期', trigger: 'blur' },
        ],
        done_time: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
        domicile_place: [
          { required: true, message: '请输入户籍所在地', trigger: 'blur' },
        ],
        present_address: [
          { required: true, message: '请输入现住址', trigger: 'blur' },
        ],
        birth_year: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
        is_social_security: [
          { required: true, message: '请选择是否已入社保', trigger: 'change' },
        ],
      },

      options: [], // 部门
      gender_options: [
        { name: '男', value: 1 },
        { name: '女', value: 2 },
      ],
      is_social_security_options: [
        { name: '否', value: 0 },
        { name: '是', value: 1 },
      ],
      is_marry_options: [
        { name: '是', value: '是' },
        { name: '否', value: '否' },
      ],
      job_type_options: [
        { name: '全职', value: 1 },
        { name: '兼职', value: 2 },
        { name: '实习', value: 3 },
      ],
      staff_status_options: [
        { name: '不使用系统人员', value: 1 },
        { name: '使用人员', value: 2 },
        { name: '待离职', value: 3 },
        { name: '已离职', value: 4 },
      ],
      user_status_options: [
        { name: '试用', value: 1 },
        { name: '正式', value: 2 },
      ],

      optional_education: [
        {
          id: '0-0',
          this_situation: true,
          education_background: '',
          specialty: '',
          school_name: '',
          ed_time: [],
        },
      ],
      optional_education_id: 0,
      work_experience: [
        {
          id: '1-0',
          this_situation: true,
          company_name: '',
          department_name: '',
          salary: '',
          work_time: [],
        },
      ],
      work_experience_id: 0,
      family_information: [
        {
          id: '2-0',
          this_situation: true,
          family_name: '',
          family_relation: '',
          family_phone: '',
          family_profession: '',
        },
      ],
      family_information_id: 0,

      form: {
        name: '', // 姓名
        mobile: '', // 手机号
        age: '', // 年龄
        gender: '', // 性别
        // position: '', // 职位
        ed_id: '', // 部门ID
        id_card: '', // 身份证号
        is_marry: '', // 是否婚配
        bank_branch: '', // 支行
        credit_card_num: '', // 银行卡号
        job_type: '', // 工作性质
        staff_status: '', // 人员类型
        user_status: '', // 员工状态
        internship: '', // 试用期
        is_social_security: '', // 是否已入社保
        domicile_place: '', // 户籍所在地
        present_address: '', // 现住址
        nation: '', // 民族
        email: '', // 邮箱
        political: '', // 政治面貌
        job_num: '', // 员工号
        education_background: '', // 学历
        specialty: '', // 专业
        skill: '', // 技能
        physical_condition: '', // 身体状况
        hobby: '', // 爱好
        birth_year: '', // 出生年
        birth_month: '', // 出生月
        join_time: '', // 入职时间
        done_time: '', // 转正时间
        leave_time: '', // 离职时间
      },
      array_form: {
        join_time: '', // 入职时间
        done_time: '', // 转正时间
        leave_time: '', // 离职时间
        birth: '', // 出生年月
      },
      staff_id: '',
      loading: false,
    }
  },
  created() {
    this.department_list()
    if (this.$route.params.staff_id) {
      this.staff_detail()
    }
    // console.log('添加/编辑', this.$route.params.staff_id)
  },
  methods: {
    department_list() {
      // 部门
      require('post', '/lufish_hrm/v1/department_list/', {}).then((res) => {
        if (!res.code) {
          console.log(res)
          this.options = res.data
        }
      })
    },
    staff_detail() {
      // 获取详情
      this.loading = true
      require('post', '/lufish_hrm/v1/staff_detail/', {
        staff_id: this.$route.params.staff_id,
      }).then((res) => {
        console.log('详情', res)
        if (!res.code) {
          this.data_staff_data(res.data[0].staff_data[0])
          this.data_education_data(res.data[0].education_data)
          this.data_work_experience_data(res.data[0].work_experience_data)
          this.data_family_data(res.data[0].family_data)
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    data_staff_data(e) {
      // 基本内容
      // form_birth()
      e.department_info[e.department_info.length - 1] = e.ed_id
      this.cascader_ed_id = e.department_info
      // console.log('基础内容', e.department_info, e.ed_id)
      // console.log('内容', this.cascader_ed_id)
      for (let i in this.form) {
        if (e[i] != null) {
          if (i == 'join_time' || i == 'done_time' || i == 'leave_time') {
            this.array_form[i] = e[i] * 1000
          } else if (i == 'birth_year') {
            this.array_form.birth = e[i] + '-' + e.birth_month
          } else if (i == 'ed_id') {
          }
          this.form[i] = e[i]
        }
      }
      // console.log(' 当前基础内容 ', this.form)
    },
    data_education_data(e) {
      // 教育背景
      let add = []
      this.optional_education_id = e.length == 0 ? 1 : e.length
      if (e.length != 0) {
        for (let i = 1; i <= e.length; i++) {
          let i_name = i - 1
          let Obj = {
            id: '0-' + i_name,
            this_situation: true,
            education_background:
              e[i - 1].education_background == null
                ? ''
                : e[i - 1].education_background,
            specialty: e[i - 1].specialty == null ? '' : e[i - 1].specialty,
            school_name:
              e[i - 1].school_name == null ? '' : e[i - 1].school_name,
          }
          console.log('教育背景内容', Obj)

          if (e[i - 1].ed_start_time != 0) {
            Obj.ed_time = [
              e[i - 1].ed_start_time * 1000,
              e[i - 1].ed_end_time * 1000,
            ]
          } else {
            Obj.ed_time = []
          }
          add.push(Obj)
        }
        this.optional_education = add
      }
    },
    data_work_experience_data(e) {
      // 工作经历
      let add = []
      this.work_experience_id = e.length == 0 ? 1 : e.length
      if (e.length != 0) {
        for (let i = 1; i <= e.length; i++) {
          let i_name = i - 1
          let Obj = {
            id: '1-' + i_name,
            this_situation: true,
            company_name:
              e[i - 1].company_name == null ? '' : e[i - 1].company_name,
            department_name:
              e[i - 1].department_name == null ? '' : e[i - 1].department_name,
            salary: e[i - 1].salary == null ? '' : e[i - 1].salary,
          }
          console.log('工作经历内容', Obj)
          if (e[i - 1].work_start_time != 0) {
            Obj.work_time = [
              e[i - 1].work_start_time * 1000,
              e[i - 1].work_end_time * 1000,
            ]
          } else {
            Obj.work_time = []
          }
          add.push(Obj)
        }
        this.work_experience = add
      }
    },
    data_family_data(e) {
      // 家庭信息
      let add = []
      this.family_information_id = e.length == 0 ? 1 : e.length
      if (e.length != 0) {
        for (let i = 1; i <= e.length; i++) {
          let i_name = i - 1
          let Obj = {
            id: '2-' + i_name,
            this_situation: true,
            family_name:
              e[i - 1].family_name == null ? '' : e[i - 1].family_name,
            family_relation:
              e[i - 1].family_relation == null ? '' : e[i - 1].family_relation,
            family_phone:
              e[i - 1].family_phone == null ? '' : e[i - 1].family_phone,
            family_profession:
              e[i - 1].family_profession == null
                ? ''
                : e[i - 1].family_profession,
          }
          console.log('家庭信息内容', Obj)
          add.push(Obj)
        }
        this.family_information = add
      }
    },
    return_os() {
      // this.$router.push({ name: 'organizational_structure', params: { chuan_shen: '返回' }})f
      this.$router.go(-1)
    },
    cascader_checkStrictly(e) {
      console.log('name', e)
      this.form.ed_id = e[e.length - 1]
    },
    onSubmit() {
      // 保存
      // console.log('创建', this.rules)
      let education_list = [],
        work_experience_list = [],
        family_list = []
      let mobile_zhengze = /^1(3|4|5|6|7|8|9)\d{9}$/
      let zhengze = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      for (let i in this.rules) {
        if (this.form[i] !== '') {
          if (i == 'id_card' && !zhengze.test(this.form[i])) {
            console.log('zhengze.test(this.form[i])', this.form[i])
            this.$message.error('请检测当前必填选项是否有误或未填')
            return false
            break
          } else if (i == 'mobile' && !mobile_zhengze.test(this.form[i])) {
            console.log('mobile_zhengze.test(this.form[i])', this.form[i])
            this.$message.error('请检测当前必填选项是否有误或未填')
            return false
            break
          }
        } else {
          console.log('测试', this.form[i], i)
          this.$message.error('请检测当前必填选项是否有误或未填')
          return false
          break
        }
      }
      // this.form.join_time = this.array_form.join_time/1000;
      // this.form.done_time = this.array_form.done_time/1000;
      // this.form.leave_time = this.array_form.leave_time/1000;

      this.optional_education.forEach((item) => {
        if (item.this_situation) {
          let ed_start_time = '',
            ed_end_time = ''
          if (item.ed_time.length > 0) {
            ed_start_time = item.ed_time[0] / 1000
            ed_end_time = item.ed_time[1] / 1000
          }
          education_list.push({
            school_name: item.school_name,
            education_background: item.education_background,
            specialty: item.specialty,
            ed_start_time: ed_start_time,
            ed_end_time: ed_end_time,
          })
        }
      })
      this.work_experience.forEach((item) => {
        if (item.this_situation) {
          let work_start_time = '',
            work_end_time = ''
          if (item.work_time.length > 0) {
            work_start_time = item.work_time[0] / 1000
            work_end_time = item.work_time[1] / 1000
          }
          work_experience_list.push({
            company_name: item.company_name,
            department_name: item.department_name,
            salary: item.salary,
            work_start_time: work_start_time,
            work_end_time: work_end_time,
          })
        }
      })
      this.family_information.forEach((item) => {
        if (item.this_situation) {
          family_list.push({
            family_name: item.family_name,
            family_relation: item.family_relation,
            family_phone: item.family_phone,
            family_profession: item.family_profession,
          })
        }
      })

      if (this.$route.params.staff_id) {
        // 修改
        require('post', '/lufish_hrm/v1/add_update_staff/', {
          // 创建
          label_code: 'update',
          staff_id: this.$route.params.staff_id,
          staff_update_data: this.form,
          education_update_list: education_list,
          work_experience_update_list: work_experience_list,
          family_update_list: family_list,
        }).then((res) => {
          // console.log(res);
          if (!res.code) {
            this.$message({ message: res.msg, type: 'success' })
            this.$router.go(-1)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        // 添加
        require('post', '/lufish_hrm/v1/add_update_staff/', {
          // 创建
          label_code: 'create',
          staff_data: this.form,
          education_list,
          work_experience_list,
          family_list,
        }).then((res) => {
          // console.log(res);
          if (!res.code) {
            this.$message({ message: res.msg, type: 'success' })
            // this.empty()
            this.$router.go(-1)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    empty() {
      this.optional_education = [
        {
          id: '0-0',
          this_situation: true,
          education_background: '',
          specialty: '',
          school_name: '',
          ed_time: [],
        },
      ]
      ;(this.optional_education_id = 0),
        (this.work_experience = [
          {
            id: '1-0',
            this_situation: true,
            company_name: '',
            department_name: '',
            salary: '',
            work_time: [],
          },
        ])
      this.work_experience_id = 0
      this.family_information = [
        {
          id: '2-0',
          this_situation: true,
          family_name: '',
          family_relation: '',
          family_phone: '',
          family_profession: '',
        },
      ]
      this.family_information_id = 0
      this.form = {
        name: '', // 姓名
        mobile: '', // 手机号
        age: '', // 年龄
        gender: '', // 性别
        // position: '', // 职位
        ed_id: '', // 部门ID
        id_card: '', // 身份证号
        is_marry: '', // 是否婚配
        bank_branch: '', // 支行
        credit_card_num: '', // 银行卡号
        job_type: '', // 工作性质
        staff_status: '', // 人员类型
        user_status: '', // 员工状态
        internship: '', // 试用期
        is_social_security: '', // 是否已入社保
        domicile_place: '', // 户籍所在地
        present_address: '', // 现住址
        nation: '', // 民族
        email: '', // 邮箱
        political: '', // 政治面貌
        job_num: '', // 员工号
        education_background: '', // 学历
        specialty: '', // 专业
        skill: '', // 技能
        physical_condition: '', // 身体状况
        hobby: '', // 爱好
        birth_year: '', // 出生年
        birth_month: '', // 出生月
        join_time: '', // 入职时间
        done_time: '', // 转正时间
        leave_time: '', // 离职时间
      }
      this.array_form = {
        join_time: '', // 入职时间
        done_time: '', // 转正时间
        leave_time: '', // 离职时间
        birth: '', // 出生年月
      }
    },
    add_options(e) {
      if (e == '0') {
        // 教育背景
        this.optional_education_id++
        this.optional_education.push({
          id: '0-' + this.optional_education_id,
          this_situation: true,
          education_background: '',
          specialty: '',
          school_name: '',
          ed_time: [],
        })
      } else if (e == 1) {
        this.work_experience_id++
        this.work_experience.push({
          id: '1-' + this.work_experience_id,
          this_situation: true,
          company_name: '',
          department_name: '',
          salary: '',
          work_time: [],
        })
      } else if (e == 2) {
        this.family_information_id++
        this.family_information.push({
          id: '2-' + this.family_information_id,
          this_situation: true,
          family_name: '',
          family_relation: '',
          family_phone: '',
          family_profession: '',
        })
      }
    },
    add_delete(e, id) {
      let that = this
      if (e == '0') {
        this.$confirm('确定要删除当前选项吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          that.optional_education.forEach((element) => {
            if (element.id == id) {
              element.this_situation = false
            }
          })
        })
      } else if (e == '1') {
        this.$confirm('确定要删除当前选项吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          that.work_experience.forEach((element) => {
            if (element.id == id) {
              element.this_situation = false
            }
          })
        })
      } else if (e == '2') {
        this.$confirm('确定要删除当前选项吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          that.family_information.forEach((element, index) => {
            if (element.id == id) {
              element.this_situation = false
            }
          })
        })
      }
      console.log('删除', e, id)
    },

    form_item(name, e) {
      console.log(name, typeof e)
      if (typeof e == 'number') {
        this.form[name] = e / 1000
      } else {
        this.form[name] = ''
      }
      console.log(this.form[name])
    },
    form_birth(e) {
      if (e != null) {
        let add = e.split('-')
        this.form['birth_year'] = add[0]
        this.form['birth_month'] = add[1]
      } else {
        this.form['birth_year'] = ''
        this.form['birth_month'] = ''
      }
    },
  },
  computed: {
    education_reversedMessage: function () {
      let add = []
      this.optional_education.forEach((item) => {
        if (item.this_situation) {
          add.push(item)
        }
      })
      // console.log('计算后的教育', add)
      return add
    },
    work_reversedMessage: function () {
      let add = []
      this.work_experience.forEach((item) => {
        if (item.this_situation) {
          add.push(item)
        }
      })
      return add
    },
    family_reversedMessage: function () {
      let add = []
      this.family_information.forEach((item) => {
        if (item.this_situation) {
          add.push(item)
        }
      })
      return add
    },
  },
}
</script>

<style>
.create_infor {
  display: flex;
  justify-content: space-between;
}
.el_form_item {
  width: 50%;
}
.el_input {
  margin: 6px 0;
  width: 80%;
  min-width: 300px;
}
.dividing_line {
  border: 1px #409eff solid;
  width: 100%;
}
.optional_center {
  display: flex;
  justify-content: space-between;
}
.add_options {
  display: flex;
  align-items: center;
  width: 80px;
}
.time_frame {
  display: flex;
}
.for_add_options_p {
  width: 30%;
  margin: 20px auto;
  border: 1px #eee solid;
}
.delete_center {
  padding-right: 30px;
  display: flex;
  justify-content: flex-end;
}
.onSubmit {
  display: flex;
  justify-content: flex-end;
  margin: 15px;
}
</style>


// WEBPACK FOOTER //
// src/personnel_matters/add_employee.vue